import script from "./SolutionCloudComputer.vue?vue&type=script&setup=true&lang=js"
export * from "./SolutionCloudComputer.vue?vue&type=script&setup=true&lang=js"

import "./SolutionCloudComputer.vue?vue&type=style&index=0&id=633f385f&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-633f385f"]])

export default __exports__